import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { IChatMessageModel } from 'models/chatMessage.model'

export const CREATE_CHAT_MESSAGE = 'CREATE_CHAT_MESSAGE'
export const CREATE_CHAT_MESSAGE_SUCCESS = 'CREATE_CHAT_MESSAGE_SUCCESS'
export const GET_CHAT_MESSAGES = 'GET_CHAT_MESSAGES'
export const GET_CHAT_MESSAGES_SUCCESS = 'GET_CHAT_MESSAGES_SUCCESS'
export const GET_CHAT_CONVERSATION_MESSAGES = 'GET_CHAT_CONVERSATION_MESSAGES'
export const GET_CONVERSATIONS = 'GET_CONVERSATIONS'
export const GET_CONVERSATIONS_SUCCESS = 'GET_CONVERSATIONS_SUCCESS'
export const GET_UNREAD_MESSAGES_COUNT = 'GET_UNREAD_MESSAGES_COUNT'
export const GET_UNREAD_MESSAGES_COUNT_SUCCESS = 'GET_UNREAD_MESSAGES_COUNT_SUCCESS'
export const GET_COURSE_UNREAD_MESSAGES_COUNT = 'GET_COURSE_UNREAD_MESSAGES_COUNT'
export const GET_COURSE_UNREAD_MESSAGES_COUNT_SUCCESS = 'GET_COURSE_UNREAD_MESSAGES_COUNT_SUCCESS'
export const DESTROY_CHAT_MESSAGE = 'DESTROY_CHAT_MESSAGE'

export const Actions = {
  createChatMessage: (data: IChatMessageModel) => createAction(CREATE_CHAT_MESSAGE, data),
  createChatMessageSuccess: (conversationId?: any) => createAction(CREATE_CHAT_MESSAGE_SUCCESS, conversationId),
  getChatMessages: (courseId: number) => createAction(GET_CHAT_MESSAGES, courseId),
  getChatMessagesSuccess: (data: any) => createAction(GET_CHAT_MESSAGES_SUCCESS, data),
  getConversations: (userId: number) => createAction(GET_CONVERSATIONS, userId),
  getConversationsSuccess: (data: any) => createAction(GET_CONVERSATIONS_SUCCESS, data),
  getConversationMessages: (courseId: number, conversationId: number) => createAction(GET_CHAT_CONVERSATION_MESSAGES, { courseId, conversationId }),
  getUnreadMessagesCount: () => createAction(GET_UNREAD_MESSAGES_COUNT),
  getUnreadMessagesCountSuccess: (count: number) => createAction(GET_UNREAD_MESSAGES_COUNT_SUCCESS, count),
  getCourseUnreadMessagesCount: () => createAction(GET_COURSE_UNREAD_MESSAGES_COUNT),
  getCourseUnreadMessagesCountSuccess: (count: number) => createAction(GET_COURSE_UNREAD_MESSAGES_COUNT_SUCCESS, count),
}

export type Actions = ActionsUnion<typeof Actions>
